// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SecurityResolvedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SecurityResolvedIcon" ref={forwardedRef} {...props}>
      <path d="m9 13 4.42-4.42-1.07-1.068L9 10.862 7.575 9.44l-1.069 1.069z" />
      <path d="M16.5 4.894v7.048a5 5 0 0 1-2.916 4.546L10 18.13l-3.584-1.642A5 5 0 0 1 3.5 11.943v-7.05a1 1 0 0 1 .835-.985l1.97-.329a3 3 0 0 0 .849-.276L10 1.88l2.443 1.222a6 6 0 0 0 1.696.551l1.525.255A1 1 0 0 1 16.5 4.894m-9.458 10.23 2.959 1.356 2.958-1.356A3.5 3.5 0 0 0 15 11.942V5.317l-1.107-.184a7.5 7.5 0 0 1-2.12-.69L10 3.557 7.826 4.645a4.5 4.5 0 0 1-1.273.414L5 5.318v6.625a3.5 3.5 0 0 0 2.041 3.181" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SecurityResolvedIcon = /* @__PURE__ */ Object.assign(
  SecurityResolvedIconComponent,
  { displayName: 'SecurityResolvedIcon' },
);
